class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);
        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        }
        window.addEventListener('popstate', onHistoryChange);
    }
    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }
    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }
        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = element => element.url === url;
            FacetFiltersForm.filterData.some(filterDataUrl) ?
                FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
                FacetFiltersForm.renderSectionFromFetch(url, event);
        });
        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
            });
    }
    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
    }
    static renderProductGridContainer(htmls) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(htmls, 'text/html').getElementById('ProductGridContainer').innerHTML;
        // check color value is shown
        function checkFilter(thi) {
            if (!$('li.list-menu__item.facets__item.color_value' + thi + ':eq(0) label input').hasClass("yes_active")) {
                if ($('li.list-menu__item.facets__item.color_value' + thi + ':eq(1) label input').hasClass("yes_active")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0) label').click();
                } else if ($('li.list-menu__item.facets__item.color_value' + thi + ':eq(2) label input').hasClass("yes_active")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0) label').click();
                } else if ($('li.list-menu__item.facets__item.color_value' + thi + ':eq(3) label input').hasClass("yes_active")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0) label').click();
                } else if ($('li.list-menu__item.facets__item.color_value' + thi + ':eq(4) label input').hasClass("yes_active")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0) label').click();
                } else if ($('li.list-menu__item.facets__item.color_value' + thi + ':eq(5) label input').hasClass("yes_active")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0) label').click();
                }
            }
            if ($('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ' label.mobile-facets__label.mobile-facets__label--disabled:eq(0)').html()) {
                if (!$('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ' label.mobile-facets__label:eq(1)').hasClass("mobile-facets__label--disabled")) {
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(1)').css("display", "block");
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(0)').css("display", "none");
                } else if (!$('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ' label.mobile-facets__label:eq(2)').hasClass("mobile-facets__label--disabled")) {
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(0)').css("display", "none");
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(2)').css("display", "block");
                } else if (!$('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ' label.mobile-facets__label:eq(3)').hasClass("mobile-facets__label--disabled")) {
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(0)').css("display", "none");
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(3)').css("display", "block");
                } else if (!$('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ' label.mobile-facets__label:eq(4)').hasClass("mobile-facets__label--disabled")) {
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(0)').css("display", "none");
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(4)').css("display", "block");
                } else if (!$('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ' label.mobile-facets__label:eq(5)').hasClass("mobile-facets__label--disabled")) {
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(0)').css("display", "none");
                    $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(5)').css("display", "block");
                }
            } else {
                $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(0)').css("display", "");
                $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(1)').css("display", "");
                $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(2)').css("display", "");
                $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(3)').css("display", "");
                $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(4)').css("display", "");
                $('li.mobile-facets__item.list-menu__item.color_mb_value' + thi + ':eq(5)').css("display", "");
            }
            if ($('li.list-menu__item.facets__item.color_value' + thi + ' label.facet-checkbox.facet-checkbox--disabled:eq(0)').html()) {
                if (!$('li.list-menu__item.facets__item.color_value' + thi + ' label.facet-checkbox:eq(1)').hasClass("facet-checkbox--disabled")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(1)').css("display", "block");
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0)').css("display", "none");
                } else if (!$('li.list-menu__item.facets__item.color_value' + thi + ' label.facet-checkbox:eq(2)').hasClass("facet-checkbox--disabled")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0)').css("display", "none");
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(2)').css("display", "block");
                } else if (!$('li.list-menu__item.facets__item.color_value' + thi + ' label.facet-checkbox:eq(3)').hasClass("facet-checkbox--disabled")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0)').css("display", "none");
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(3)').css("display", "block");
                } else if (!$('li.list-menu__item.facets__item.color_value' + thi + ' label.facet-checkbox:eq(4)').hasClass("facet-checkbox--disabled")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0)').css("display", "none");
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(4)').css("display", "block");
                } else if (!$('li.list-menu__item.facets__item.color_value' + thi + ' label.facet-checkbox:eq(5)').hasClass("facet-checkbox--disabled")) {
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0)').css("display", "none");
                    $('li.list-menu__item.facets__item.color_value' + thi + ':eq(5)').css("display", "block");
                }
            } else {
                $('li.list-menu__item.facets__item.color_value' + thi + ':eq(0)').css("display", "");
                $('li.list-menu__item.facets__item.color_value' + thi + ':eq(1)').css("display", "");
                $('li.list-menu__item.facets__item.color_value' + thi + ':eq(2)').css("display", "");
                $('li.list-menu__item.facets__item.color_value' + thi + ':eq(3)').css("display", "");
                $('li.list-menu__item.facets__item.color_value' + thi + ':eq(4)').css("display", "");
                $('li.list-menu__item.facets__item.color_value' + thi + ':eq(5)').css("display", "");
            }
        }
        checkFilter("pink");
        checkFilter("multicolor");
        checkFilter("blue");
        checkFilter("green");
        checkFilter("red");
        checkFilter("purple");
//product limit set using custom script
  function coll_product_limit_set() {
     if($('.load-more_wrap button').html() && !$('.loadmore_page').hasClass("hidden")){
var f = "";
$(".grid--4-col-desktop .grid__item").each(function(e, o){

    var g = e + 1;
	
    var r = $('.grid--4-col-desktop .grid__item').length;
	
   if($(window).width() > 990){
   //Desktop device script condition
     f = $('.grid--4-col-desktop .grid__item').length % 4;
	
   }else{
   //Mobile device script condition
        f = $('.grid--4-col-desktop .grid__item').length % 2;
	   
   }
    var h = r - f;
	
    if(g > h && r > 7){
	//extra items hide
        $(this).hide();

    }else{
//hide items show
         $(this).show();

    }
});

//console.log("product_hided"+f);

}else{

$(".grid--4-col-desktop .grid__item").show();

//console.log("all Product show");

}
  }
  //filter time product limit set
  coll_product_limit_set();
      
        // check option is avaiable
        $(".card-size-swatch .variant_swatchess_2 input.card_checked").each(function () {
            var op_this = $(this);
            var size_v = $(this).val();

            var data = $(this).closest("li.grid__item").find('script.productVariants').html();
            if (!data) {
                var data = $(this).closest("li.grid__item").find('script.productVariants').html();
            }
            data = $.parseJSON(data);
            if ($(this).closest("li.grid__item").find(".card-color-swatch fieldset.variant_swatchess input").val()) {
                var color_v = $(this).closest("li.grid__item").find(".card-color-swatch fieldset.variant_swatchess input.card_checked").val();
            } else {
                var color_v = null;
            }
           if ($(this).closest("li.grid__item").find(".variant_swatchess_3 input").val()) {
        var style__v = $(this).closest("li.grid__item").find(".variant_swatchess_3 input.card_checked").val();
         $(op_this).closest("li.grid__item").find('.variant_swatchess_3 input').addClass("card_dis");
      } else {
        var style__v = null;
      }
            var colr_v = $(this).closest("li.grid__item").find(".card-color-swatch fieldset.variant_swatchess input.card_checked").val();
            $(this).closest("li.grid__item").find(".card-size-swatch .variant_swatchess_2 input").addClass("card_dis");
            $(this).closest("li.grid__item").find(".card-color-swatch fieldset.variant_swatchess input").addClass("card_dis");
            var ava_badge = true;
            data.product.forEach(function (i, o) {
                if (colr_v == i.option1 && i.available) {
                    $(op_this).closest("li.grid__item").find('.card-size-swatch .variant_swatchess_2 input[value="' + i.option2 + '"]').removeClass("card_dis");
                }
                if (size_v == i.option2 && i.available) {
                    $(op_this).closest("li.grid__item").find('.card-color-swatch fieldset.variant_swatchess input[value="' + i.option1 + '"]').removeClass("card_dis");
                }
              if (size_v == i.option2 && i.available && colr_v == i.option1) {
$(op_this).closest("li.grid__item").find('.variant_swatchess_3 input[value="' + i.option3 + '"]').removeClass("card_dis");
        }
                if (colr_v == i.option1 && size_v == i.option2 && i.available) {
                    ava_badge = false;
                }
            });
            if ($(op_this).closest("li.grid__item").find('.card-size-swatch .variant_swatchess_2 input').length == $(op_this).closest("li.grid__item").find('.card-size-swatch .variant_swatchess_2 input.card_dis').length) {
                $(op_this).closest("li.grid__item").find('.quick-buy-poup').addClass('quick-buy-poup-dis_popup');
            }
            if (ava_badge) {
                $(op_this).closest("li.grid__item").find('.badge.badge--bottom-left.color-inverse').removeClass("hidden");
                $(op_this).closest("li.grid__item").find('.card__badge.top.left').html(`<span class="badge badge--bottom-left color-inverse">Sold Out</span>`);
            } else {
                $(op_this).closest("li.grid__item").find('.badge.badge--bottom-left.color-inverse').addClass("hidden");
            }
        });
      //search result count after seprated product
        if ($('.search_heading .search_heading-result span').html()) {
            var le = $('.grid.product-grid li').length;
            var $this = $('button.btn.js-load-more'), totalPages = parseInt($('[data-total-pagess]').val()), currentPage = parseInt($('[data-current-pages]').val());
            if (currentPage && currentPage == 1) {
                for (let index = 1; index < totalPages; index++) {
                    currentPage = currentPage + 1;
                    var nextUrl = $('[data-next-urls]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
                    $.ajax({
                        url: nextUrl,
                        type: 'GET',
                        dataType: 'html',
                        success: function (responseHTML) {
                            le = le + $(responseHTML).find('.product-grid li').length;
                        },
                        complete: function () {
                        }
                    })
                }
                setTimeout(function () {
                    $('.search_heading .search_heading-result span').html(le + " styles found"); 
                }, 700 * totalPages);
            }
        }
    }
    static renderProductCount(html_c) {
        async function html_c(html) {
            const count_p = await new DOMParser().parseFromString(html, 'text/html');
            if (count_p && count_p.getElementById('ProductCount')) {
                const count = count_p.getElementById('ProductCount').innerHTML
                const container = document.getElementById('ProductCount');
                const containerDesktop = document.getElementById('ProductCountDesktop');
                container.innerHTML = count;
                container.classList.remove('loading');
                if (containerDesktop) {
                    containerDesktop.innerHTML = count;
                    containerDesktop.classList.remove('loading');
                }
            }
        }
        html_c(html_c);
    }
    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElements =
            parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });
        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);
        if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }
    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        })
        FacetFiltersForm.toggleActiveFacets(false);
    }
    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });
        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');
        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');
        if (sourceElement && targetElement) {
            target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }
        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
    }
    static updateURLHash(searchParams) {
//       console.log(window.location)
//       console.log(searchParams)
// console.log(`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
      var loca = window.location.search.replace("?", "").split("&");
var newuri = "";
if(loca.length > 1){
    loca.forEach(function(u){
        if(u.indexOf("filter") != 0){
             if(u.indexOf("sort_by") != 0){
          newuri += "&"+u;
             }
        }
    })
}
else{
 if(loca[0].indexOf("filter") != 0){
             if(loca[0].indexOf("sort_by") != 0 && loca[0] != ""){
            newuri += "&"+loca[0];
             }
        }
    
}
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}${newuri}`);
    }
    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            }
        ]
    }
    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }
    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }
    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'))
            this.onSubmitForm(searchParams, event)
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        const noJsElements = document.querySelectorAll('.no-js-list');
                        noJsElements.forEach((el) => el.remove());
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'FacetFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join('&'), event)
        }
    }
    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input')
            .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }
    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }
    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}
customElements.define('price-range', PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }
    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}
customElements.define('facet-remove', FacetRemove);
